<script>
import Twilio from "./Twilio";
import Jitsi from "./Jitsi";
import { videoRoomEngine } from "@/services/config";

export default {
  name: "VideoRoom",

  props: {
    patientId: {
      type: String,
      require: true,
    },
    appointmentId: {
      type: String,
    },
  },

  components: {
    Twilio,
    Jitsi,
  },

  data() {
    return {
      roomId: "",
      isLoading: false,
      isAudioEnabled: true,
      isVideoEnabled: true,
      room: "",
      state: "pending",
      videoRoomEngine,
    };
  },
};
</script>

<!-- TODO: Read env var to decide which video provider to use -->
<template lang="pug">
span
  Jitsi(
    v-if="videoRoomEngine === 'jitsi'"
    :patientId="patientId"
    :appointmentId="appointmentId"
  )
  Twilio(
    v-if="videoRoomEngine === 'twilio'"
    :patientId="patientId"
    :appointmentId="appointmentId"
  )
</template>

<style lang="scss"></style>
